import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, ZapIcon, GiftIcon } from 'lucide-react';
import { trackAddToCart, trackInitiateCheckout } from '../utils/metaPixel';
const CART_URL = 'https://checkout.volveaserdeseada.com/cart/add?id=42732657344599&quantity=1&return_to=%2Fcart';
const CTA_TEXT = 'Quiero volver a sentirme deseada →';
export function Hero() {
  const handleClick = () => {
    trackAddToCart();
    trackInitiateCheckout();
    window.location.href = CART_URL;
  };
  return <section className="pt-8 pb-6 md:pt-32 md:pb-16 px-5" data-id="element-84">
      <div className="max-w-2xl mx-auto" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-86">
          {/* Brand mark */}
          <h1 className="mb-5 md:mb-7 font-playfair text-center" data-id="element-87">
            <span className="block text-[56px] sm:text-[64px] md:text-7xl lg:text-8xl font-light tracking-[0.18em] uppercase text-[#9B1B30] leading-[1.05]" style={{
            textShadow: '0 2px 16px rgba(156, 122, 90, 0.12)'
          }} data-id="element-88">
              LUMEIA
            </span>
            <span className="block mt-1 text-[14px] md:text-base font-normal italic tracking-[0.28em] uppercase text-[#B89B85]" data-id="element-89">
              Volvé a ser deseada
            </span>
          </h1>

          {/* Emotional headline */}
          <h2 className="font-playfair text-[24px] md:text-[34px] leading-[1.2] text-burgundy text-center mb-3 md:mb-4 font-light" data-id="element-90">
            Volvé a sentirte deseada
            <br data-id="element-91" />
            <span className="italic" data-id="element-92">sin perseguir atención.</span>
          </h2>

          {/* Subhead */}
          <p className="text-[14px] md:text-base leading-snug text-charcoal/65 text-center mb-5 md:mb-6 max-w-md mx-auto" data-id="element-93">
            Recuperá la conexión, la tensión y la energía en tu relación con
            herramientas emocionales y prácticas que podés aplicar desde hoy.
          </p>

          {/* Offer badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex justify-center mb-4" data-id="element-94">
            <span className="inline-block px-3 py-1.5 rounded-full bg-burgundy/10 border border-burgundy/20 text-[11px] md:text-sm font-semibold text-burgundy tracking-wide" data-id="element-95">
              🔥 OFERTA POR TIEMPO LIMITADO — 50% OFF
            </span>
          </motion.div>

          {/* PRICE block — visible above the fold */}
          <div className="text-center mb-5" data-id="element-96">
            <div className="inline-flex items-baseline gap-3" data-id="element-97">
              <span className="text-charcoal/40 text-lg md:text-xl line-through font-medium" data-id="element-98">
                $30.000
              </span>
              <span className="font-playfair text-[40px] md:text-5xl font-bold text-burgundy leading-none" data-id="element-99">
                $14.999
              </span>
            </div>
            <p className="text-[12px] md:text-sm text-charcoal/55 mt-1.5 italic" data-id="element-100">
              precio en pesos argentinos · pago único
            </p>
          </div>

          {/* CTA */}
          <div className="text-center" data-id="element-101">
            <button onClick={handleClick} className="inline-block w-full sm:w-auto bg-burgundy hover:bg-burgundy/90 text-white font-bold text-[15px] md:text-lg px-8 md:px-10 py-4 md:py-5 rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-102">
              {CTA_TEXT}
            </button>
          </div>

          {/* Trust signals row — visible right under CTA */}
          <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-5 text-[12px] md:text-sm text-charcoal/70" data-id="element-103">
            <div className="flex items-center gap-1.5" data-id="element-104">
              <ZapIcon className="w-4 h-4 text-burgundy" strokeWidth={2} data-id="element-105" />
              <span className="font-medium" data-id="element-106">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-107">
              <GiftIcon className="w-4 h-4 text-burgundy" strokeWidth={2} data-id="element-108" />
              <span className="font-medium" data-id="element-109">7 bonus incluidos</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-110">
              <ShieldCheckIcon className="w-4 h-4 text-burgundy" strokeWidth={2} data-id="element-111" />
              <span className="font-medium" data-id="element-112">Garantía 7 días</span>
            </div>
          </div>

          {/* Soft social proof — credible for new brand */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="mt-4 flex items-center justify-center gap-2" data-id="element-113">
            <div className="flex" data-id="element-114">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-gold text-gold" data-id="element-115" />)}
            </div>
            <p className="text-[12px] md:text-sm font-medium text-charcoal/60" data-id="element-116">
              Cada semana, más mujeres comienzan este cambio
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}